import { gql } from '@apollo/client'

export const GET_COUNTRIES_HR_IS_RESPONSIBLE_FOR = gql`
  query FindCountriesHrIsResponsibleOf {
    findCountriesHrIsResponsibleOf
  }
`
